import {Component, Inject } from '@angular/core';
import {MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogRef as MatDialogRef} from '@angular/material/dialog';
import {ArticleService} from '../../../services/article.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ShoppingService } from '../../../services/shopping.service';

@Component({
    selector: 'brover-save-order-dialog',
    templateUrl: './save-order-dialog.component.html',
    styleUrls: ['./save-order-dialog.component.sass'],
    standalone: false
})
export class SaveOrderDialogComponent {

  public order: {
    deliverDate: Date,
    shoppingBag: any[],
    references?: string,
    car_type: any,
    brand: any,
    address: string,
    place: string,
    postal_code: string
  };

  constructor(
    public articleService: ArticleService,
    public dialogRef: MatDialogRef<SaveOrderDialogComponent>,
    // tslint:disable-next-line:max-line-length
    @Inject(MAT_DIALOG_DATA) public data: any, private router: Router, private active: ActivatedRoute, private shoppingService: ShoppingService) {
      this.order = data;
    }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  addCard() {
    if (this.order.references.length > 0 && this.order.shoppingBag.length > 0) {
      this.articleService.setCard(
        this.order.shoppingBag,
        this.order.references,
        this.order.car_type.id,
        this.order.brand.id
      ).subscribe((x) => {
        console.log(x);
        const order = this.shoppingService.order;
        order.shoppingBag = Object.assign(this.order.shoppingBag);
        order.brand = this.order.brand;
        order.car_type = this.order.car_type;
        order.references = this.order.references;
        this.dialogRef.close(x['success']);
        // dashboard/place-order/overview/ordered/false?from=tenders&tenderId=136
        // http://localhost:4200/dashboard/place-order/overview/ordered/false?from=tenders&tenderId=480
        this.router.navigate(['/', 'dashboard', 'place-order', 'overview', 'ordered', `false`], {queryParams: {from: 'tenders', tenderId: x['data']['id'], tenderCreated: true}});
      });
    }
  }
}
